/**
 * Character Sheet — play view. MERGED only. Players never see Sheet A/B
 * during play; the split is only on the level-up page and via the
 * "Sheet A / Sheet B" management buttons in the header (TBD).
 *
 * Stub uses an example character to prove the data model compiles end-to-end.
 */
import {
  Character,
  mergedScores,
  totalHp,
  proficiencyBonus,
  combinedLevel,
} from '../lib/character';

const example: Character = {
  id: 'example',
  name: 'Example Character',
  base: { STR: 16, DEX: 14, CON: 12, INT: 10, WIS: 13, CHA: 8 },
  conSheet: 'A',
  sheetA: {
    className: 'Paladin',
    subclass: 'Oath of the Watchers',
    level: 8,
    hitDieTotal: 56,
    asiDeltas: { STR: 2 },
    featDeltas: {},
    magicItemDeltas: {},
    proficiencies: { athletics: 'proficiency', persuasion: 'proficiency' },
    feats: [],
  },
  sheetB: {
    className: 'Warlock',
    subclass: 'The Undying',
    level: 8,
    hitDieTotal: 44,
    asiDeltas: { CHA: 2 },
    featDeltas: {},
    magicItemDeltas: {},
    proficiencies: { arcana: 'proficiency', deception: 'expertise' },
    feats: [],
  },
};

export default function Sheet() {
  const stats = mergedScores(example);
  return (
    <div>
      <h1>{example.name}</h1>
      <p>
        Level <span className="numeric">{combinedLevel(example)}</span> ·
        Prof <span className="numeric">+{proficiencyBonus(example)}</span> ·
        HP <span className="numeric">{totalHp(example)}</span>
      </p>
      <table>
        <thead>
          <tr>
            <th>STR</th><th>DEX</th><th>CON</th><th>INT</th><th>WIS</th><th>CHA</th>
          </tr>
        </thead>
        <tbody>
          <tr className="numeric">
            <td>{stats.STR}</td>
            <td>{stats.DEX}</td>
            <td>{stats.CON}</td>
            <td>{stats.INT}</td>
            <td>{stats.WIS}</td>
            <td>{stats.CHA}</td>
          </tr>
        </tbody>
      </table>
      <p>
        <span className="sheet-a">{example.sheetA.className}</span> /{' '}
        <span className="sheet-b">{example.sheetB.className}</span>
      </p>
    </div>
  );
}
